<template>
  <main class="cj-wrap" dir="ltr" :style="desktopBackgroundStyle">
    <header class="header-top">
      <h1 :style="{fontSize: controlInfo.titleFontSize + 'px', color: controlInfo.titleFontColor}" >{{controlInfo.activityTitle}}</h1>
      <button type="button" class="rules" @click.stop="openRule">Rules</button>
    </header>
    <header class="header-mobile">
      <strong class="mobile-title">{{controlInfo.activityTitle}}</strong>
      <button type="button" class="mobile-rules" @click.stop="openRule">Rules</button>
    </header>
    <main class="cj-body-mobile">
      <div class="project-list">
        <div class="title">
          <img src="@/assets/images/icon-title1.png" alt="" class="image1">
          Prize List
          <img src="@/assets/images/icon-title2.png" alt="" class="image2">
        </div>
        <div class="swiper">
          <button
              type="button"
              class="carousel-control is-prev"
              aria-label="Previous prize"
              :disabled="mobilePrizeIndex <= 0"
              @click.stop="moveMobileAwards(-1)"
          >‹</button>
          <van-swipe
              ref="mobileSwipeRef"
              class="my-swipe"
              :loop="false"
              :width="mobileSwipeItemWidth"
              :show-indicators="false"
              dir="ltr"
              @change="handleMobileSwipeChange"
          >
            <van-swipe-item v-for="(item, index) in prizeList" :key="index">
              <div class="item-box" @click="handleSelect(index)">
                <div class="item" :class="{'is-selected': item.id === selectAwardItem.id}" dir="ltr">
                  <img :src="resolveResourceUrl(item.img)" :alt="item.prizeName" class="pic" draggable="false">
                  <p class="award" :title="item.awardName">{{ item.awardName }}</p>
                  <p class="name" :title="item.prizeName">{{ item.prizeName }}</p>
                  <span class="remain">Last {{item.surplusNum}}</span>
                </div>
              </div>
            </van-swipe-item>
          </van-swipe>
          <button
              type="button"
              class="carousel-control is-next"
              aria-label="Next prize"
              :disabled="mobilePrizeIndex >= prizeList.length - 1"
              @click.stop="moveMobileAwards(1)"
          >›</button>
        </div>
      </div>
      <div class="cj-box">
        <div class="prize" v-if="selectAwardItem.id">
          <div class="title">
            <img src="@/assets/images/icon-title1.png" alt="" class="image1">
            Lucky Prize
            <img src="@/assets/images/icon-title2.png" alt="" class="image2">
          </div>
          <div class="info-box">
            <div class="info">
              <img :src="resolveResourceUrl(selectAwardItem.img)" alt="" class="pic">
              <p class="prize-name">{{ selectAwardItem.prizeName }}</p>
            </div>
            <div class="text">
              This Round Will Select <span>{{selectAwardItem.perNum}}</span> People.
            </div>
          </div>
        </div>
        <div class="countdown">
          <div class="title">
            <img src="@/assets/images/icon-title1.png" alt="" class="image1">
            Countdown to Draw
            <img src="@/assets/images/icon-title2.png" alt="" class="image2">
          </div>
          <div class="countdown-box" :class="`is-${drawStage}`">
            <template v-if="drawStage === 'ready'">
              <div class="count">
                <van-count-down v-if="hasScheduledCountdown" :time="remainTime" @finish="handleFinish">
                  <template #default="timeData">
                    <span class="block" :key="`mobile-hour-${timeData.hours}`">{{ formatClockUnit(timeData.hours) }}</span>
                    <div class="colon">:</div>
                    <span class="block" :key="`mobile-minute-${timeData.minutes}`">{{ formatClockUnit(timeData.minutes) }}</span>
                    <div class="colon">:</div>
                    <span class="block" :key="`mobile-second-${timeData.seconds}`">{{ formatClockUnit(timeData.seconds) }}</span>
                  </template>
                </van-count-down>
                <div v-else class="ready-copy">Ready</div>
              </div>

              <button
                  v-if="isManualDraw"
                  type="button"
                  class="draw-action"
                  @click="handleManualLottery"
              >Enter Now</button>
            </template>

            <template v-else-if="drawStage === 'drawing'">
              <div class="rolling-name">
                <span class="rolling-name-value" :key="curName">{{ curName || 'Drawing...' }}</span>
              </div>
              <button
                  v-if="isManualDraw"
                  type="button"
                  class="draw-action"
                  :class="{'is-disabled': isSubmittingLottery}"
                  :disabled="isSubmittingLottery"
                  @click="handleStopLottery"
              >{{ isSubmittingLottery ? 'Drawing...' : 'Stop Draw' }}</button>
            </template>
          </div>
        </div>
      </div>
      <div class="zj-list">
        <div class="title">
          <img src="@/assets/images/icon-title1.png" alt="" class="image1">
          <span>Winning Records</span>
          <img src="@/assets/images/icon-title2.png" alt="" class="image2">
        </div>
        <div class="list records-scroll" id="mobile-records-list">
          <van-list
              v-model:loading="loading"
              :finished="finished"
              finished-text="No more records."
              loading-text="Loading..."
              @load="onLoad"
          >
            <template #loading>
              <span v-if="winList.length">Loading...</span>
            </template>
            <template #finished>
              <span v-if="winList.length">No more records.</span>
            </template>
            <div class="item" v-for="(item, index) in winList" :key="index">
              <div class="icon-prize-name">
               Prize Name
              </div>
              <div class="item-top">
                <span class="name">{{ item.prizeName }}</span>
                <span class="time" dir="ltr">{{ formatRecordTime(item.createTime) }}</span>
              </div>
              <p class="names">{{item.winnerNames.join(', ')}}</p>
            </div>
          </van-list>
          <div class="records-overview">
            <span>View All Records</span>
            <span class="overview-arrow" aria-hidden="true"></span>
          </div>
        </div>
      </div>
    </main>
    <main class="cj-body">
      <div class="project-list">
        <div class="title">
          <img src="@/assets/images/icon-title1.png" alt="" class="image1">
          Prize List
          <img src="@/assets/images/icon-title2.png" alt="" class="image2">
        </div>
        <button
            type="button"
            class="carousel-control is-prev"
            aria-label="Previous prize"
            :disabled="desktopPrizeIndex >= prizeList.length - 1"
            @click="scrollDesktopAwards(1)"
        >«</button>
        <div
            ref="desktopPrizeListRef"
            class="list"
        >
          <button type="button" class="item" :class="{'is-selected': item.id === selectAwardItem.id}"
                  v-for="(item, index) in prizeList" :key="index" @click="handleSelect(index)">
            <img :src="resolveResourceUrl(item.img)" alt="" class="pic" draggable="false">
            <div class="info">
              <p class="award">{{ item.awardName }}</p>
              <p class="name">{{ item.prizeName }}</p>
            </div>
            <div class="remain">Last {{item.surplusNum}}</div>
          </button>
        </div>
        <button
            type="button"
            class="carousel-control is-next"
            aria-label="Next prize"
            :disabled="desktopPrizeIndex <= 0"
            @click="scrollDesktopAwards(-1)"
        >»</button>
      </div>
      <div class="cj-box">
        <img src="@/assets/images/lucky-draw.png" alt="" class="lucky-draw">
        <div class="prize" v-if="selectAwardItem.id">
          <div class="title">
            <img src="@/assets/images/icon-title1.png" alt="" class="image1">
            Lucky Prize
            <img src="@/assets/images/icon-title2.png" alt="" class="image2">
          </div>
          <div class="info-box">
            <div class="info">
              <div class="prize-image">
                <img :src="resolveResourceUrl(selectAwardItem.img)" :alt="selectAwardItem.prizeName" class="pic">
              </div>
              <p class="prize-name">{{ selectAwardItem.prizeName }}</p>
            </div>
            <div class="text">
              This Round Will Select <span>{{selectAwardItem.perNum}}</span> People.
            </div>
          </div>
        </div>
        <div class="countdown">
          <div class="title">
            <img src="@/assets/images/icon-title1.png" alt="" class="image1">
            Countdown to Draw
            <img src="@/assets/images/icon-title2.png" alt="" class="image2">
          </div>
          <div class="countdown-box" :class="`is-${drawStage}`">
            <template v-if="drawStage === 'ready'">
              <div class="count">
                <van-count-down v-if="hasScheduledCountdown" :time="remainTime" @finish="handleFinish">
                  <template #default="timeData">
                    <span class="block" :key="`desktop-hour-${timeData.hours}`">{{ formatClockUnit(timeData.hours) }}</span>
                    <div class="colon">:</div>
                    <span class="block" :key="`desktop-minute-${timeData.minutes}`">{{ formatClockUnit(timeData.minutes) }}</span>
                    <div class="colon">:</div>
                    <span class="block" :key="`desktop-second-${timeData.seconds}`">{{ formatClockUnit(timeData.seconds) }}</span>
                  </template>
                </van-count-down>
                <div v-else class="ready-copy">Ready</div>
              </div>

              <button
                  v-if="isManualDraw"
                  type="button"
                  class="draw-action"
                  @click="handleManualLottery"
              >Enter Now</button>
            </template>

            <template v-else-if="drawStage === 'drawing'">
              <div class="rolling-name">
                <span class="rolling-name-value" :key="curName">{{ curName || 'Drawing...' }}</span>
              </div>
              <button
                  v-if="isManualDraw"
                  type="button"
                  class="draw-action"
                  :class="{'is-disabled': isSubmittingLottery}"
                  :disabled="isSubmittingLottery"
                  @click="handleStopLottery"
              >{{ isSubmittingLottery ? 'Drawing...' : 'Stop Draw' }}</button>
            </template>
          </div>
        </div>
      </div>
      <div class="zj-list">
        <div class="title">
          <img src="@/assets/images/icon-title1.png" alt="" class="image1">
          Winning Records
          <img src="@/assets/images/icon-title2.png" alt="" class="image2">
        </div>
        <div class="list records-scroll" id="desktop-records-list">
          <van-list
              v-model:loading="loading"
              :finished="finished"
              finished-text="No more records."
              loading-text="Loading..."
              @load="onLoad"
          >
            <template #loading>
              <span v-if="winList.length">Loading...</span>
            </template>
            <template #finished>
              <span v-if="winList.length">No more records.</span>
            </template>
            <div class="item" v-for="(item, index) in winList" :key="index">
              <div class="icon-prize-name">
                Prize Name
              </div>
              <div class="record-top">
                <p class="name">{{ item.prizeName }}</p>
                <p class="time" dir="ltr">{{ formatRecordTime(item.createTime) }}</p>
              </div>
              <p class="zj-names">
                {{ item.winnerNames.join(',') }}
              </p>
            </div>
          </van-list>
          <div class="records-overview">
            <span>View All Records</span>
            <span class="overview-arrow" aria-hidden="true"></span>
          </div>
        </div>
      </div>
    </main>
    <draw-rule :controlInfo="controlInfo" @close-rule="isRule = false;" v-if="isRule"/>
    <big-win
        :result="result"
        :prizeName="prizeName"
        :prizeImg="selectAwardItem.img"
        @close-result="closeResult"
        v-if="isResult"
    />
<!--    <big-win :result="['111', '222', '333']" :prizeName="prizeName" @close-result="closeResult"/>-->
  </main>
</template>
<script setup>
import DrawRule from "@/components/DrawRule.vue";
import {ref, computed, onBeforeUnmount, onMounted} from "vue";
import BigWin from "@/components/BigWin.vue";
import {
  controlDetail,
  drawLottery,
  getGroupList,
  getNewRecord,
  lotteryGetAll,
  lotteryList,
  serverTime
} from "@/api/home";
import {resolveResourceUrl, transformTime} from "@/utils/transform";

const formatClockUnit = (value) => String(value ?? 0).padStart(2, '0')

const formatRecordTime = (dateTime) => {
  if(!dateTime) {
    return ''
  }

  const rawValue = String(dateTime).trim()
  const dateParts = rawValue.match(/(\d{4})[-\/]?(\d{1,2})[-\/]?(\d{1,2})[T\s]*(\d{1,2}):(\d{1,2})(?::(\d{1,2}))?/)

  if(dateParts) {
    const [, , , , hour, minute] = dateParts
    return `${hour.padStart(2, '0')}:${minute.padStart(2, '0')}`
  }

  const parsedDate = new Date(dateTime)
  if(Number.isNaN(parsedDate.getTime())) {
    return rawValue
  }

  const padTimeUnit = (value) => String(value).padStart(2, '0')
  return `${padTimeUnit(parsedDate.getHours())}:${padTimeUnit(parsedDate.getMinutes())}`
}

const mobileSwipeRef = ref(null)
const mobilePrizeIndex = ref(0)
const mobileSwipeItemWidth = ref(260)
const desktopPrizeListRef = ref(null)

const updateMobileSwipeItemWidth = () => {
  const availableWidth = Math.min(Math.max(window.innerWidth - 32, 0), 343)
  mobileSwipeItemWidth.value = 260 * (availableWidth / 343)
}

const moveMobileAwards = (step) => {
  const targetIndex = Math.min(
    Math.max(mobilePrizeIndex.value + step, 0),
    Math.max(prizeList.value.length - 1, 0)
  )

  if(targetIndex === mobilePrizeIndex.value) {
    return
  }

  mobileSwipeRef.value?.swipeTo(targetIndex)
}

const handleMobileSwipeChange = (index) => {
  mobilePrizeIndex.value = index
  handleSelect(index)
}

const scrollDesktopAwards = (step) => {
  const list = desktopPrizeListRef.value
  if(!list || prizeList.value.length === 0) {
    return
  }

  const targetIndex = Math.min(
    Math.max(desktopPrizeIndex.value + step, 0),
    prizeList.value.length - 1
  )

  if(targetIndex === desktopPrizeIndex.value) {
    return
  }

  const targetItem = list.querySelectorAll(':scope > .item')[targetIndex]
  targetItem?.scrollIntoView({
    behavior: 'smooth',
    block: 'nearest',
    inline: 'center'
  })
  handleSelect(targetIndex)
}

/*
* 0.活动设置信息
* 奖项列表不用分页
* */
const audioBg = ref(null)
const audioZj = ref(null)
const controlInfo = ref({})
const desktopBackgroundStyle = computed(() => {
  const backgroundImage = resolveResourceUrl(controlInfo.value.backgroundImage)
  return {
    '--desktop-background-image': backgroundImage ? `url(${backgroundImage})` : 'none'
  }
})

const playWinningSound = async () => {
  if(controlInfo.value.enableSound !== '1' || !audioZj.value) {
    return
  }

  try {
    audioZj.value.currentTime = 0
    await audioZj.value.play()
  }catch(err) {
    // 浏览器禁止自动播放或音频格式不受支持时，不中断抽奖流程。
    console.warn('Winning sound could not be played:', err)
  }
}

const getControlInfo = () => {
  controlDetail().then(res => {
    controlInfo.value = res
    // 设置标题
    document.title = res.activityTitle
    // audioBg.value = new Audio(controlInfo.value.backgroundSound)
    const winningSoundUrl = resolveResourceUrl(res.winningSound)
    audioZj.value = winningSoundUrl ? new Audio(winningSoundUrl) : null
    if(audioZj.value) {
      audioZj.value.preload = 'auto'
    }
    // if(controlInfo.value.enableSound === '1') {
    //   const ua = navigator.userAgent;
    //   if( /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)) {
    //     document.addEventListener('touchstart', function () {
    //       // 2. 播放音频
    //       audioBg.value.play();
    //       audioBg.value.loop = true
    //     }, {once: true});
    //   }else {
    //     document.addEventListener('click', function() {
    //       audioBg.value.play();
    //       audioBg.value.loop = true
    //     }, { once: true });
    //   }
    // }
  }).catch(err => {})
}
getControlInfo()

/*
* 1.抽奖规则显示
* */
const isRule = ref(false)
const openRule = () => {
  isRule.value = true
}

/*
* 2.获取奖项列表
* 奖项列表不用分页
* */

const nextItem = ref({})
const getNextItem = () => {
  // 定时开奖的奖项，寻找下一轮待开奖的轮次
  if(isAutomaticDraw.value) {
    nextItem.value = selectAwardItem.value.drawTimeList.find(item => {
      return item.status === 'pending'
    }) || {}
  }else {
    nextItem.value = {}
  }
}

const prizeList = ref([])
const selectAwardItem = ref({})
const desktopPrizeIndex = computed(() => {
  const index = prizeList.value.findIndex(item => item.id === selectAwardItem.value.id)
  return index >= 0 ? index : 0
})
const isManualDraw = computed(() => Number(selectAwardItem.value.drawType) === 0)
const isAutomaticDraw = computed(() => Number(selectAwardItem.value.drawType) === 1)
const getPrizeList = () => {
  lotteryGetAll().then(res => {
    // 获取奖项列表
    prizeList.value = res
    // 获取当前要显示的奖项
    if(res.length > 0) {
      // 如果没有当前奖项，则选第一个
      if(!selectAwardItem.value.id) {
        selectAwardItem.value = res[0]
      }else {
        // 如果有，当前奖项不变，但是由于抽奖后奖项剩余数据会变，则需要重新选中这个奖项，重新赋值
        selectAwardItem.value = res.find(item => {
          return selectAwardItem.value.id === item.id
        }) || {}
        // 增加下架功能，考虑到正好下架了当前奖项的情况
        if(!selectAwardItem.value.id) {
          selectAwardItem.value = res[0]
        }
      }
    }else {
      selectAwardItem.value = {}
    }
    // 获取当前奖项的组别人员，因为手动开奖需要滚动人员名单
    getGroupNames()
    // 针对当前奖项是定时开奖的情况，本轮自动抽奖完成，需要获取下一轮自动开奖时间，再进行倒计时
    getNextItem()
  }).catch(err => {})
}
const timeZone = ref({})
const getTimeZone = () => {
  serverTime().then(res => {
    timeZone.value = res
    getPrizeList()
  }).catch(err => {})
}
getTimeZone()



/*
* 3.获取中奖列表
* 中奖列表需要分页
* */
const winList = ref([])
const pageNo = ref(1)
const count = ref(0)
const initFinish = ref(false)
const loading = ref(true)
const finished = ref(false)
const lists = ref([])
const handleInit = () => {
  pageNo.value = 1
  count.value = 0
  loading.value = true
  finished.value = false
}
const getWinList = () => {
  lotteryList({
    pageNo: pageNo.value,
    pageSize: 10
  }).then(res => {
    winList.value = winList.value.concat(res.lists)
    initFinish.value = true
    count.value = res.count
    loading.value = false
  }).catch(err => {})
}
getWinList()
const onLoad = () => {
  console.log('onLoad',)
  if(pageNo.value === 0) {
    pageNo.value ++
    getWinList()
  }else{
    if(winList.value.length < count.value) {
      pageNo.value ++
      getWinList()
    }else{
      finished.value = true
    }
  }
}

/*
* 4.抽奖操作
* 手动开奖
* */
const prizeName = ref('')
const result = ref([])
const isLottery = ref(false)
const isSubmittingLottery = ref(false)
const isResult = ref(false)
// 获取分组人员名单
const groupNames = ref([])
const getGroupNames = () => {
  if(selectAwardItem.value.surplusNum !== 0) {
    getGroupList({
      groupId: selectAwardItem.value.groupId
    }).then(res => {
      groupNames.value = res
    }).catch(err => {})
  }
}
const timer = ref(null)
const outTimer = ref(null)
const curName = ref('')
const MANUAL_DRAW_DELAY = 5000
const NAME_ROLL_INTERVAL = 120

const getMemberName = (member) => {
  if(typeof member === 'string') {
    return member
  }

  return member?.name || member?.winnerName || ''
}

const rollRandomName = () => {
  if(groupNames.value.length === 0) {
    curName.value = 'Drawing...'
    return
  }

  let nextName = curName.value
  const maxAttempts = groupNames.value.length > 1 ? 5 : 1

  for(let attempt = 0; attempt < maxAttempts && nextName === curName.value; attempt++) {
    const index = Math.floor(Math.random() * groupNames.value.length)
    nextName = getMemberName(groupNames.value[index])
  }

  curName.value = nextName || 'Drawing...'
}

// 启动随机名单滚动，手动和自动开奖共用。
const startNameRolling = () => {
  if(isLottery.value || !selectAwardItem.value.id || Number(selectAwardItem.value.surplusNum) <= 0) {
    return false
  }

  isLottery.value = true

  clearInterval(timer.value)
  rollRandomName()
  timer.value = setInterval(rollRandomName, NAME_ROLL_INTERVAL)

  return true
}

// 手动开奖只能由 Enter Now 按钮触发。
const handleManualLottery = () => {
  if(!isManualDraw.value || !startNameRolling()) {
    return
  }

  isSubmittingLottery.value = false
  clearTimeout(outTimer.value)
  outTimer.value = setTimeout(() => {
    outTimer.value = null
    handleStopLottery()
  }, MANUAL_DRAW_DELAY)
}
// 抽奖动画结束后调用接口并显示结果
const handleStopLottery = () => {
  if(!isManualDraw.value || !isLottery.value || isSubmittingLottery.value) {
    return
  }

  isSubmittingLottery.value = true
  clearTimeout(outTimer.value)
  outTimer.value = null
  clearInterval(timer.value)
  timer.value = null
  curName.value = ''
  drawLottery({
    awardId: selectAwardItem.value.id
  }).then(res => {
    if(controlInfo.value.enableSound === '1') {
      // audioBg.value.pause();
      playWinningSound()
    }
    result.value = res
    if(res.length > 0) {
      prizeName.value = res[0].awardName
    }else {
      prizeName.value = ''
    }
    isSubmittingLottery.value = false
    isLottery.value = false
    isResult.value = true
    getPrizeList()
    handleInit()
    lotteryList({pageNo: 1, pageSize: 10}).then(res => {
      winList.value = res.lists
      initFinish.value = true
      count.value = res.count
      loading.value = false
    }).catch(err => {})
  }).catch(err => {
    isSubmittingLottery.value = false
    isLottery.value = false
  })
}

// 获取倒计时需要的剩余开奖毫秒数
// const remainTime = computed(() => {
//   const nowTime = new Date().getTime()
//   const lotteryTime = new Date(nextItem.value.time).getTime()
//   return lotteryTime - nowTime
// })
// 获取倒计时需要的剩余开奖毫秒数
const remainTime = computed(() => {
  const nowTime = transformTime(timeZone.value.timeZone)
  const lotteryTime = new Date(nextItem.value.time).getTime()
  return lotteryTime - nowTime
})

const hasScheduledCountdown = computed(() => {
  return isAutomaticDraw.value && Boolean(nextItem.value.time) && remainTime.value > 0
})

const drawStage = computed(() => {
  if(!selectAwardItem.value.id) {
    return 'finished'
  }

  if(isLottery.value) {
    return 'drawing'
  }

  if(Number(selectAwardItem.value.surplusNum) <= 0) {
    return 'finished'
  }

  if(isAutomaticDraw.value && !nextItem.value.time) {
    return 'finished'
  }

  return 'ready'
})

/*
* 5.抽奖操作
* 自动开奖
* */
const handleFinish = () => {
  // 自动开奖不响应按钮，只在倒计时结束后启动名单滚动。
  if(!isAutomaticDraw.value || !startNameRolling()) {
    return
  }

  outTimer.value = setTimeout(() => {
    clearInterval(timer.value)
    timer.value = null
    curName.value = ''
    getNewRecord({
      awardId: selectAwardItem.value.id
    }).then(res => {
      result.value = res.winnerNames
      prizeName.value = res.awardName
      if(controlInfo.value.enableSound === '1') {
        playWinningSound()
        // audioBg.value.pause();
      }
      isLottery.value = false
      isResult.value = true
      clearTimeout(outTimer.value)
      outTimer.value = null
      getPrizeList()
      lotteryList({pageNo: 1, pageSize: 10}).then(res => {
        handleInit()
        winList.value = res.lists
        count.value = res.count
        loading.value = false
      }).catch(err => {})
    }).catch(err => {})
  }, 3000)
}

// 点击切换当前奖项
const handleSelect = (index) => {
  if(isLottery.value) {
    return
  }

  document.querySelectorAll('.records-scroll').forEach(list => {
    list.scrollTop = 0
  })
  clearTimeout(outTimer.value)
  outTimer.value = null
  clearInterval(timer.value)
  timer.value = null
  curName.value = ''
  selectAwardItem.value = prizeList.value[index]
  getPrizeList()
  lotteryList({pageNo: 1, pageSize: 10}).then(res => {
    handleInit()
    winList.value = res.lists
    count.value = res.count
    loading.value = false
  }).catch(err => {})
}

// 关闭中奖结果
const closeResult = () => {
  isResult.value = false
  if(audioZj.value) {
    audioZj.value.pause()
    audioZj.value.currentTime = 0
  }
  // audioBg.value.play()
}

onMounted(() => {
  updateMobileSwipeItemWidth()
  window.addEventListener('resize', updateMobileSwipeItemWidth)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateMobileSwipeItemWidth)
  clearTimeout(outTimer.value)
  clearInterval(timer.value)
  outTimer.value = null
  timer.value = null
})
</script>
<style scoped lang="scss">
$panel: rgba(255, 246, 231, 0.97);
$panel-border: #ffc9c5;
$card: #ffdda2;
$red: #d52212;
$orange: #ff9b1c;

.cj-wrap {
  --desktop-background-image: none;
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  background-color: #003d25;
  background-image: var(--desktop-background-image);
  background-position: top center;
  background-size: cover;
  background-repeat: no-repeat;
  color: $red;
  font-family: Arial, Helvetica, sans-serif;
}

.header-top {
  width: 100%;
  height: clamp(90px, 5.7292vw, 110px);
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  direction: ltr;

  h1 {
    max-width: 68vw;
    margin: 0;
    padding-top: clamp(24px, 1.875vw, 36px);
    overflow: hidden;
    color: #65ed42;
    font-size: clamp(42px, 3.125vw, 60px);
    line-height: 1.08;
    font-weight: 900;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    -webkit-text-stroke: 2px #159607;
    text-shadow: 0 3px 0 #086e05;
  }

  .rules {
    width: 85px;
    height: 34px;
    position: absolute;
    top: 53px;
    right: 26px;
    padding: 0 14px;
    border: 1px solid #50e73c;
    border-radius: 999px;
    background: #08792b;
    color: #fff;
    font-family: inherit;
    font-size: 16px;
    line-height: 32px;
    font-weight: 700;
    cursor: pointer;
  }
}

.header-mobile,
.cj-body-mobile {
  display: none;
}

.cj-body {
  width: min(93.75vw, 1800px);
  height: calc(100vh - clamp(90px, 5.7292vw, 110px) - 40PX - 60PX);
  min-height: 640px;
  max-height: 870px;
  display: grid;
  grid-template-columns: 18.6667% 46.6667% 18.6667%;
  column-gap: 8%;
  margin: 40PX auto 60PX;
  direction: ltr;

  .title {
    width: 136px;
    aspect-ratio: 343 / 84;
    position: absolute;
    top: -10px;
    left: 50%;
    z-index: 8;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 14px;
    background: url("@/assets/frame/btn-bgk.png") center / 100% 100% no-repeat;
    color: #fff;
    font-size: clamp(14px, 0.9375vw, 18px);
    line-height: 1;
    font-weight: 700;
    text-align: center;
    white-space: nowrap;
    transform: translateX(-50%);

    .image1,
    .image2 {
      display: none;
    }
  }
}

.cj-body > .project-list,
.cj-body > .zj-list,
.cj-body > .cj-box .prize {
  border: 2px solid $panel-border;
  background: $panel;
  box-shadow: 0 4px 12px rgba(124, 29, 12, 0.08);
}

.cj-body > .project-list {
  grid-column: 1;
  width: 100%;
  height: 100%;
  position: relative;
  padding: 44px 18px 18px;
  overflow: visible;
  border-radius: 20px;

  > .list {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
    overflow-x: hidden;
    overflow-y: auto;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  > .carousel-control {
    display: none;
  }

  .item {
    width: 100%;
    height: calc((100% - 60px) / 6);
    min-height: 104px;
    flex: 0 0 auto;
    position: relative;
    display: flex;
    align-items: center;
    padding: 10px 12px;
    overflow: hidden;
    border: 0;
    border-radius: 12px;
    background: $card;
    color: $red;
    font-family: inherit;
    text-align: left;
    cursor: pointer;

    &.is-selected {
      box-shadow: inset 0 0 0 2px rgba(255, 146, 20, 0.32);
    }

    &:focus-visible {
      outline: 3px solid $orange;
      outline-offset: -3px;
    }

    .pic {
      width: 96px;
      height: 86px;
      flex: 0 0 96px;
      margin-right: 8px;
      object-fit: contain;
      pointer-events: none;
    }

    .info {
      flex: 1 1 auto;
      min-width: 0;
      align-self: center;
    }

    .award,
    .name {
      width: 100%;
      margin: 0;
      overflow: hidden;
      color: $red;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .award {
      margin-bottom: 8px;
      font-size: clamp(13px, 0.8333vw, 16px);
      line-height: 1.15;
      font-weight: 400;
    }

    .name {
      font-size: clamp(18px, 1.1979vw, 23px);
      line-height: 1.15;
      font-weight: 700;
    }

    .remain {
      min-width: 54px;
      height: 25px;
      position: absolute;
      top: 12px;
      right: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 9px;
      border-radius: 999px;
      background: linear-gradient(180deg, #ff8586 0%, #ff1919 82%);
      box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.65);
      color: #fff;
      font-size: 14px;
      line-height: 1;
      white-space: nowrap;
    }
  }
}

.cj-body > .cj-box {
  grid-column: 2;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .lucky-draw {
    display: none;
  }

  .prize {
    width: 100%;
    height: clamp(225px, 14.0104vw, 269px);
    position: relative;
    margin-top: 6px;
    overflow: visible;
    border-radius: 30px;

    > .title {
      width: 163px;
      top: -16px;
    }

    .info-box {
      position: absolute;
      inset: 40px 38px 0;
    }

    .info {
      height: calc(100% - 70px);
      position: relative;
      overflow: hidden;
      border-radius: 19px;
      background: $card;
      text-align: center;
    }

    .prize-image {
      display: contents;
    }

    .pic {
      width: 150px;
      height: 96px;
      position: absolute;
      left: 50%;
      bottom: 12px;
      object-fit: contain;
      transform: translateX(-50%);
    }

    .prize-name {
      width: calc(100% - 32px);
      position: absolute;
      top: 10px;
      left: 16px;
      margin: 0;
      overflow: hidden;
      color: $red;
      font-size: clamp(19px, 1.25vw, 24px);
      line-height: 1.2;
      font-weight: 700;
      text-align: center;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .text {
      height: 70px;
      position: absolute;
      right: -38px;
      bottom: 0;
      left: -38px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      color: #f12410;
      font-size: clamp(17px, 1.0417vw, 20px);
      line-height: 1.2;
      text-align: center;

      span {
        color: inherit;
        font-size: 1.25em;
        font-weight: 700;
      }
    }
  }

  .countdown {
    width: 100%;
    height: clamp(270px, 16.25vw, 312px);
    position: relative;
    border: 8px solid #ffd8d0;
    border-radius: 46px;
    background: #ffe8bf;
    box-shadow: 0 5px 12px rgba(126, 38, 7, 0.16);

    &::before {
      content: "";
      position: absolute;
      inset: 4px;
      border: 8px solid #ffa51f;
      border-radius: 39px;
      pointer-events: none;
    }

    > .title {
      width: clamp(286px, 17.8646vw, 343px);
      top: -31px;
      font-size: clamp(22px, 1.5625vw, 30px);
      font-weight: 800;
    }

    .countdown-box {
      position: absolute;
      inset: 30px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 16px;
    }

    .count,
    .rolling-name {
      width: 100%;
      min-width: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      direction: ltr;
    }

    .rolling-name {
      height: 112px;
      padding: 0 24px;
      overflow: hidden;
    }

    .rolling-name-value {
      width: 100%;
      overflow: hidden;
      color: #ff321d;
      font-size: clamp(38px, 3.125vw, 60px);
      line-height: 1.15;
      font-weight: 900;
      text-align: center;
      text-overflow: ellipsis;
      white-space: nowrap;
      animation: rolling-name-slide 120ms linear;
    }

    :deep(.van-count-down) {
      display: flex;
      align-items: center;
      justify-content: center;
      direction: ltr;
    }

    .block,
    .colon,
    .ready-copy {
      color: #ff351f;
      font-weight: 900;
      font-variant-numeric: tabular-nums;
    }

    .block {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: clamp(82px, 7.8125vw, 150px);
      line-height: 0.9;
      letter-spacing: -0.04em;
    }

    .colon {
      width: clamp(30px, 2.3958vw, 46px);
      text-align: center;
      font-size: clamp(66px, 5.2083vw, 100px);
      line-height: 0.9;
    }

    .ready-copy {
      font-size: clamp(70px, 6.25vw, 120px);
      line-height: 1;
    }
  }
}

.draw-action {
  min-width: 230px;
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 28px;
  border: 0;
  border-radius: 999px;
  background: linear-gradient(180deg, #ffb84e 0%, #ff6816 100%);
  box-shadow: inset 0 2px 1px rgba(255, 255, 255, 0.75);
  color: #fff;
  font-family: inherit;
  font-size: 20px;
  line-height: 1;
  font-weight: 800;
  cursor: pointer;

  &.is-disabled,
  &:disabled {
    filter: grayscale(0.7);
    cursor: not-allowed;
  }
}

.cj-body > .zj-list {
  grid-column: 3;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: visible;
  border-radius: 20px;

  > .title {
    width: 162px;
  }

  > .list {
    position: absolute;
    inset: 44px 18px 14px;
    overflow: hidden;

    &::after {
      content: "";
      height: 58px;
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 4;
      background: linear-gradient(180deg, rgba(255, 246, 231, 0), $panel 88%);
      pointer-events: none;
    }
  }

  :deep(.van-list) {
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    padding-bottom: 10px;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .item {
    width: 100%;
    height: auto;
    position: relative;
    margin-bottom: 12px;
    padding: 50px 12px 12px;
    overflow: hidden;
    border-radius: 20px;
    background: $card;
    color: #a82b18;
  }

  .icon-prize-name {
    width: 100px;
    height: 40px;
    position: absolute;
    top: 8px;
    left: -6px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 8px;
    background: url("@/assets/frame/jb-bgk.png") center / 100% 100% no-repeat;
    color: #fff;
    font-size: 14px;
    line-height: 1;
    font-weight: 700;
    white-space: nowrap;
  }

  .record-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 7px;
  }

  .name,
  .time,
  .zj-names {
    margin: 0;
  }

  .name {
    min-width: 0;
    overflow: hidden;
    color: #931d0f;
    font-size: clamp(18px, 1.1458vw, 22px);
    line-height: 1.15;
    font-weight: 700;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .time {
    position: absolute;
    top: 21px;
    right: 12px;
    color: #cb8478;
    font-size: 14px;
    line-height: 1;
    font-variant-numeric: tabular-nums;
  }

  .zj-names {
    display: block;
    color: #ae3b27;
    font-size: clamp(14px, 0.9375vw, 18px);
    line-height: 1.2;
    overflow-wrap: anywhere;
  }

  .records-overview {
    display: none;
  }

  .overview-arrow {
    width: 9px;
    height: 9px;
    border-top: 2px solid currentColor;
    border-right: 2px solid currentColor;
    transform: rotate(45deg);
  }
}

:deep(.van-list__finished-text),
:deep(.van-list__loading) {
  height: 28px;
  color: #c77768;
  font-size: 12px;
  line-height: 28px;
  font-weight: 400;
  opacity: 0.72;
}

@keyframes rolling-name-slide {
  from {
    opacity: 0;
    transform: translateY(55%);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media screen and (max-width: 768px) {
  .cj-wrap {
    min-height: 100vh;
    padding-bottom: 28px;
    background-image: var(--desktop-background-image);
    background-position: top center;
    background-size: cover;
    background-attachment: fixed;
  }

  .header-top,
  .cj-body {
    display: none;
  }

  .header-mobile {
    width: 100%;
    min-height: 76px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 82px 12px 16px;
    background: rgba(0, 69, 37, 0.72);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);

    .mobile-title {
      width: 100%;
      overflow: hidden;
      color: #65ed42;
      font-size: clamp(24px, 8vw, 34px);
      line-height: 1.05;
      font-weight: 900;
      text-align: center;
      text-overflow: ellipsis;
      white-space: nowrap;
      -webkit-text-stroke: 1px #159607;
      text-shadow: 0 2px 0 #086e05;
    }

    .mobile-rules {
      width: 66px;
      height: 30px;
      position: absolute;
      top: 23px;
      right: 12px;
      border: 1px solid #50e73c;
      border-radius: 999px;
      background: #08792b;
      color: #fff;
      font-family: inherit;
      font-size: 13px;
      font-weight: 700;
    }
  }

  .cj-body-mobile {
    width: min(calc(100% - 24px), 420px);
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin: 0 auto;
    padding-top: 22px;
    direction: ltr;

    .title {
      width: 158px;
      aspect-ratio: 343 / 84;
      position: absolute;
      top: -11px;
      left: 50%;
      z-index: 8;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 11px;
      background: url("@/assets/frame/btn-bgk.png") center / 100% 100% no-repeat;
      color: #fff;
      font-size: 16px;
      line-height: 1;
      font-weight: 700;
      text-align: center;
      white-space: nowrap;
      transform: translateX(-50%);

      .image1,
      .image2 {
        display: none;
      }
    }

    .project-list,
    .prize,
    .zj-list {
      border: 2px solid $panel-border;
      border-radius: 20px;
      background: $panel;
      box-shadow: 0 4px 12px rgba(124, 29, 12, 0.1);
    }

    .project-list {
      width: 100%;
      height: 236px;
      position: relative;
      overflow: visible;

      .swiper {
        position: absolute;
        inset: 43px 12px 16px;
        overflow: hidden;
        direction: ltr;
      }

      .carousel-control {
        width: 30px;
        height: 54px;
        position: absolute;
        top: 50%;
        z-index: 10;
        padding: 0;
        border: 0;
        background: rgba(255, 143, 25, 0.8);
        border-radius: 999px;
        color: #fff;
        font-size: 28px;
        line-height: 1;
        transform: translateY(-50%);

        &.is-prev {
          left: 1px;
        }

        &.is-next {
          right: 1px;
        }

        &:disabled {
          opacity: 0.25;
        }
      }

      :deep(.van-swipe),
      :deep(.van-swipe__track) {
        height: 100%;
      }

      .item-box {
        width: 260px;
        height: 100%;
        padding: 0 10px 0 32px;
      }

      .item {
        width: 218px;
        height: 100%;
        position: relative;
        display: grid;
        grid-template-columns: 78px minmax(0, 1fr);
        grid-template-rows: 20px 42px;
        align-content: center;
        align-items: center;
        column-gap: 8px;
        row-gap: 6px;
        padding: 12px 48px 12px 8px;
        overflow: hidden;
        border-radius: 14px;
        background: $card;
        color: $red;
        text-align: left;

        &.is-selected {
          box-shadow: inset 0 0 0 2px rgba(255, 146, 20, 0.44);
        }

        .pic {
          grid-column: 1;
          grid-row: 1 / span 2;
          width: 78px;
          height: 86px;
          object-fit: contain;
        }

        .award,
        .name {
          width: 100%;
          margin: 0;
          overflow: hidden;
          color: $red;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .award {
          grid-column: 2;
          grid-row: 1;
          margin-bottom: 0;
          font-size: 13px;
        }

        .name {
          grid-column: 2;
          grid-row: 2;
          font-size: 18px;
          line-height: 1.15;
          font-weight: 700;
        }

        .remain {
          min-width: 44px;
          height: 22px;
          position: absolute;
          top: 10px;
          right: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 7px;
          border-radius: 999px;
          background: linear-gradient(180deg, #ff8586, #ff1919 82%);
          color: #fff;
          font-size: 11px;
          white-space: nowrap;
        }
      }
    }

    .cj-box {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }

    .prize {
      width: 100%;
      height: 220px;
      position: relative;
      overflow: visible;

      .info-box {
        position: absolute;
        inset: 40px 14px 0;
      }

      .info {
        height: calc(100% - 58px);
        position: relative;
        overflow: hidden;
        border-radius: 16px;
        background: $card;
      }

      .pic {
        width: 120px;
        height: 82px;
        position: absolute;
        left: 50%;
        bottom: 8px;
        object-fit: contain;
        transform: translateX(-50%);
      }

      .prize-name {
        width: calc(100% - 24px);
        position: absolute;
        top: 8px;
        left: 12px;
        margin: 0;
        overflow: hidden;
        color: $red;
        font-size: 20px;
        line-height: 1.2;
        font-weight: 700;
        text-align: center;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .text {
        height: 58px;
        position: absolute;
        right: -14px;
        bottom: 0;
        left: -14px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;
        color: #f12410;
        font-size: 15px;
        text-align: center;

        span {
          font-size: 20px;
          font-weight: 700;
        }
      }
    }

    .countdown {
      width: 100%;
      height: 248px;
      position: relative;
      border: 6px solid #ffd8d0;
      border-radius: 34px;
      background: #ffe8bf;

      &::before {
        content: "";
        position: absolute;
        inset: 3px;
        border: 6px solid #ffa51f;
        border-radius: 28px;
      }

      > .title {
        width: min(78vw, 292px);
        top: -24px;
        font-size: clamp(20px, 6.4vw, 26px);
        font-weight: 800;
      }

      .countdown-box {
        position: absolute;
        inset: 32px 18px 18px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 12px;
      }

      .count,
      .rolling-name {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        direction: ltr;
      }

      .rolling-name {
        height: 82px;
        overflow: hidden;
      }

      .rolling-name-value {
        width: 100%;
        overflow: hidden;
        color: #ff351f;
        font-size: 34px;
        font-weight: 900;
        text-align: center;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      :deep(.van-count-down) {
        display: flex;
        align-items: center;
        justify-content: center;
        direction: ltr;
      }

      .block,
      .colon,
      .ready-copy {
        color: #ff351f;
        font-weight: 900;
        font-variant-numeric: tabular-nums;
      }

      .block {
        font-size: clamp(54px, 18vw, 72px);
        line-height: 0.92;
        letter-spacing: -0.04em;
      }

      .colon {
        width: 24px;
        font-size: clamp(42px, 14vw, 56px);
        line-height: 0.92;
        text-align: center;
      }

      .ready-copy {
        font-size: 64px;
      }
    }

    .draw-action {
      min-width: 180px;
      height: 46px;
      padding: 0 20px;
      font-size: 17px;
    }

    .zj-list {
      width: 100%;
      height: 560px;
      position: relative;
      overflow: visible;

      > .list {
        position: absolute;
        inset: 44px 14px 0;
        overflow: hidden;
      }

      :deep(.van-list) {
        height: calc(100% - 48px);
        overflow-x: hidden;
        overflow-y: auto;
        padding-bottom: 8px;
        scrollbar-width: none;

        &::-webkit-scrollbar {
          display: none;
        }
      }

      .item {
        min-height: 142px;
        position: relative;
        margin-bottom: 12px;
        padding: 48px 12px 12px;
        overflow: hidden;
        border-radius: 18px;
        background: $card;
      }

      .icon-prize-name {
        width: 96px;
        height: 38px;
        position: absolute;
        top: 7px;
        left: -5px;
        display: flex;
        align-items: center;
        padding-left: 8px;
        background: url("@/assets/frame/jb-bgk.png") center / 100% 100% no-repeat;
        color: #fff;
        font-size: 13px;
        font-weight: 700;
      }

      .item-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
        margin-bottom: 7px;
      }

      .name,
      .time,
      .names {
        margin: 0;
      }

      .name {
        min-width: 0;
        overflow: hidden;
        color: #931d0f;
        font-size: 20px;
        line-height: 1.15;
        font-weight: 700;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .time {
        position: absolute;
        top: 19px;
        right: 10px;
        color: #cb8478;
        font-size: 13px;
      }

      .names {
        display: block;
        color: #ae3b27;
        font-size: 16px;
        line-height: 1.3;
        overflow-wrap: anywhere;
      }

      .records-overview {
        height: 48px;
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 5;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        background: linear-gradient(180deg, rgba(255, 246, 231, 0), $panel 35%);
        color: #c77768;
        font-size: 15px;
      }

      .overview-arrow {
        width: 8px;
        height: 8px;
        border-top: 2px solid currentColor;
        border-right: 2px solid currentColor;
        transform: rotate(45deg);
      }
    }
  }

  :deep(.van-list__finished-text),
  :deep(.van-list__loading) {
    height: 24px;
    font-size: 11px;
    line-height: 24px;
  }
}

@media screen and (max-width: 374px) {
  .cj-body-mobile {
    width: calc(100% - 16px);

    .project-list {
      .item-box {
        width: 69.333vw;
        padding-left: 8.533vw;
        padding-right: 2.667vw;
      }

      .item {
        width: 58.133vw;
        padding-right: 12.8vw;

        .pic {
          width: 20.8vw;
          flex-basis: 20.8vw;
        }
      }
    }

    .countdown {
      .block {
        font-size: 17vw;
      }

      .colon {
        width: 5.5vw;
        font-size: 13vw;
      }
    }
  }
}

@media (prefers-reduced-motion: reduce) {
  .rolling-name-value {
    animation: none;
  }
}
</style>
